import type { EmcBriefingStep } from '../../utils/emcLegislationBriefing'
import { V2EmcLegislationBriefingStepShell } from './V2EmcLegislationBriefingStepShell'

export function V2EmcApplicabilityStep({
  step,
  index,
}: {
  step: EmcBriefingStep
  index: number
}) {
  return <V2EmcLegislationBriefingStepShell step={step} index={index} />
}
